import { FormattedMessage } from 'react-intl';
import Card from 'antd/lib/card';

import config from 'config/index';

import StartImport from '../../containers/StartImport';

const ImportInfo = () => (
    <Card title={<FormattedMessage id="imports.info.title" />} extra={<StartImport />}>
        {config.app.spreadsheet && (
            <FormattedMessage
                tagName="span"
                id="imports.info.link"
                values={{
                    link: (
                        <a href={config.app.spreadsheet} target="_blank" rel="noreferrer">
                            {config.app.spreadsheet}
                        </a>
                    ),
                }}
            />
        )}
    </Card>
);

export default ImportInfo;
